export default __webpack_public_path__ + "static/media/G-code-Explainer.f6cb0aa9.png";